import { debounce } from 'lodash'
import signal from 'signal-js'

const useResize = () => {

  const screens = {
    'sm': { 'min': 640, 'max': 767 },
    'md': { 'min': 768, 'max': 1023 },
    'lg': { 'min': 1024, 'max': 1279 },
    'xl': { 'min': 1280, 'max': 1535 },
    '2xl': { 'min': 1536, 'max': Infinity },
  }

  let mq

  function getCurrentScreen() {
    const width = window.innerWidth;
    return Object.keys(screens).find(key => {
      const { min, max } = screens[key];
      return width >= min && width <= max;
    }) || 'sm'
  }

  const handleResize = debounce(() => {
    if (mq !== getCurrentScreen()) {
      mq = getCurrentScreen()
      signal.emit('resize', mq)
    }
  }, 150)

  window.addEventListener('resize', handleResize)
  handleResize()
}

export default useResize
